import * as Config from '../../../../../config';
import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import { MenuItem } from "react-contextmenu";

import {
  setContextMenu
} from "../../../../../actions/index";

import IconPlayLeft from '../svg/IconPlayLeft';
import IconPlayRight from '../svg/IconPlayRight';
import IconPlus from '../svg/IconPlus';
import IconRedirect from '../svg/IconRedirect';
import IconRemove from '../svg/IconRemove';
import IconCart from '../svg/IconCart';
import IconAddedCart from '../svg/IconAddedCart';

// TODO - REWORK

const useRowAction = (
  itemID,
  playerLoadSong, addToPlaylist, toStore, 
  removeItem = null, isRestricted = false, loadToAutomix = null,
  addToCart = null, isTombstoned = null
) => {
  const dispatch = useDispatch();
  const cartItems = useSelector( state => state.cartItems );
  const isInCart = cartItems.some( id => id === itemID);
  
  const showContextMenu = () => {
    const content = [];
    // <MenuItem key={`previewItem`} onClick={previewPlayer.play(idParent, index)} data={{ action: 'Preview' }}>{`Preview Track`}</MenuItem>,
    // <div className={`separator`} />,
    if (!isRestricted && loadToAutomix === null && !isTombstoned) {
      content.push(
        <MenuItem key={`playDeck1Item`} onClick={playerLoadSong(1)} data={{ action: 'Play Deck A' }}>
          <div className={'flexRow block-contextmenu-item'}>
            <IconPlayLeft color={Config.BRAND_PRIMARY} />
            {`Load Deck A`}
          </div>
        </MenuItem>
      );
      content.push(
        <MenuItem key={`playDeck2Item`} onClick={playerLoadSong(2)} data={{ action: 'Play Deck B' }}>
          <div className={'flexRow block-contextmenu-item'}>
            <IconPlayRight color={Config.BRAND_TERTIARY} />
            {`Load Deck B`}
          </div>
        </MenuItem>
      )
    }
    if (loadToAutomix && !isTombstoned) {
      content.push(
        <MenuItem key={`loadAutomix`} onClick={loadToAutomix} data={{ action: 'Load track to automix' }}>
          <div className={'flexRow block-contextmenu-item'}>
            <IconPlayRight color={Config.BRAND_PRIMARY} />
            {`Skip to track`}
          </div>
        </MenuItem>
      )
    }
    if (addToCart && !isTombstoned) {
      content.push(
        <MenuItem key={`addToCart`} onClick={addToCart} data={{ action: 'Add' }}>
          <div className={'flexRow block-contextmenu-item'}>
            { isInCart ? <IconAddedCart color={'#8C8C8C'} size={16} /> : <IconCart color={'#8C8C8C'} size={16} /> }
            { isInCart ? `Added to cart` : `Add to cart`}
          </div>
        </MenuItem>
      );
    }
    if (!isTombstoned) {
      content.push(
        <MenuItem key={`addToPlaylist`} onClick={addToPlaylist} data={{ action: 'Add' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconPlus color={'#8C8C8C'} />
            {`Add to playlist`}
          </div>
        </MenuItem>
      );
    }
    if (removeItem) {
      content.push(
        <MenuItem key={`rPlaylist`} onClick={removeItem} data={{ action: 'Remove' }}>
          <div className={'flexRow block-contextmenu-item'}>
            <IconRemove />
            {`Remove track`}
          </div>
        </MenuItem>
      )
    }
    if (!isTombstoned) {
      content.push(
        <MenuItem key={`toStore`} onClick={toStore} data={{ action: 'To' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconRedirect />
            {`View on ${Config.capAppName()}`}
          </div>
        </MenuItem>
      )
    }
    dispatch(setContextMenu(content, {className: 'dynamic-menu-row-menu'}));
  }

  const showExtraMenu = (viewOn = false) => {
    const content = [];
    content.push(
      <MenuItem key={`addToPlaylist`} onClick={addToPlaylist} data={{ action: 'Add' }}>
        <div className={'flexRow block-contextmenu-item'}>
          <IconPlus />
          {`Add to playlist`}
        </div>
      </MenuItem>
    );
    if (addToCart) {
      content.push(
        <MenuItem key={`addToCart`} onClick={addToCart} data={{ action: 'Add' }}>
          <div className={'flexRow block-contextmenu-item'}>
            { isInCart ? <IconAddedCart color={'#EF476F'} size={16} /> : <IconCart color={'#EF476F'} size={16} /> }
            { isInCart ? `Added to cart` : `Add to cart`}
          </div>
        </MenuItem>
      );
    }
    if (viewOn) {
      content.push(
        <MenuItem key={`toStore`} onClick={toStore} data={{ action: 'To' }}>
          <div className={'flexRow block-contextmenu-item all-hover'}>
            <IconRedirect />
            {`View on ${Config.capAppName()}`}
          </div>
        </MenuItem>
      )
    }
    dispatch(setContextMenu(content, {className: 'dynamic-menu-row-menu'}));
  }

  const storeX = {
    showContextMenu,
    showExtraMenu
  };

  return storeX;
};

export default useRowAction;
